import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { EFProductWinAdd } from '@/components/UI/svg/mm100';
import ImgShowCard from '../imgShowCard';

export default function Comp({ callBack }: any) {
    const { useLang, useRouter } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('ecoflowpowerkitsseries');

    return (
        <div className={`${css.kitM} kitM`}>
            <div className="kit-ms1">{t('presale.product.kitM_ms1')}</div>
            <div className="kit-ms2">{t('presale.product.kitM_ms2')}</div>
            <ImgShowCard />
            <div className="kit-ms3">{t(locale === 'kr' ? 'presale.product.kitM_ms3_h5' : 'presale.product.kitM_ms3')}</div>
            <div className="more-win-line">
                <div className="more-win-fun" onClick={() => callBack('LFPBatteries')}>
                    {t('presale.product.h5_learn_more')}
                    <span className="more-win-fun-icon">
                        <EFProductWinAdd />
                    </span>
                </div>
            </div>
        </div>
    );
}
